export const ENV_PROD = process.env ? process.env.NODE_ENV === 'production' : __ENV_PROD__
export const ENV_DEV = process.env
  ? process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'staging'
  : __ENV_DEV__
export const URL_API = (process.env && process.env.URL_API) || __URL_API__
